export default {
  namespaced: true,

  state: {
    bounds: null,
    zoom: null
  },

  mutations: {
    setZoom (state, zoom) {
      state.zoom = zoom
    },
    setBounds(state, bounds) {
      state.bounds = bounds
    }
  },

  getters: {
    bounds: state => state.bounds,
    zoom: state => state.zoom
  }
}
